require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-girls-in-uganda-missed-out-on-celebrating-international.json") })
        }
      }, "path---en-us-update-girls-in-uganda-missed-out-on-celebrating-international");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-girls-in-uganda-missed-out-on-celebrating-international!./.cache/json/en-us-update-girls-in-uganda-missed-out-on-celebrating-international.json
// module id = 671
// module chunks = 231608221292675